// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page___yj9o","first_paint":"styles_first_paint__1HBNP"};